import React from 'react';

function DownloadSvg({height, color}) {
    return (
        <svg height={height} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.94427 9.5L2.2291 5.75L3.26935 4.6625L5.20124 6.6125V0.5H6.68731V6.6125L8.61919 4.6625L9.65944 5.75L5.94427 9.5ZM1.48607 12.5C1.0774 12.5 0.727678 12.3532 0.436904 12.0597C0.14613 11.7662 0.000495356 11.413 0 11V8.75H1.48607V11H10.4025V8.75H11.8885V11C11.8885 11.4125 11.7432 11.7657 11.4524 12.0597C11.1616 12.3537 10.8116 12.5005 10.4025 12.5H1.48607Z"
                fill={color}
            />
        </svg>
    );
}

export default DownloadSvg;